// TO BE DEPRECATED AFTER MIGRATING TO NUXT / VUE 3 PAGE ROUTING SYSTEM
import type { RouterConfig } from '@nuxt/schema'
import type { RouteRecordRaw } from 'vue-router'
import { urlCtxPartObj } from '~/types/route.entity'

export default {
  routes: (_routes: readonly RouteRecordRaw[]) => [..._routes, ...redirectRules],
} satisfies RouterConfig

const redirectRules: RouteRecordRaw[] = [
  {
    path: `${urlCtxPartObj.ORG_VIEW.path}/comp`,
    redirect: {
      name: urlCtxPartObj.ORG_VIEW.name,
    },
  },
  {
    path: urlCtxPartObj.COMP_VIEW.path,
    redirect: {
      name: urlCtxPartObj.ORG.name,
    },
  },
  // Auth Redirects
  { path: '/login', redirect: '/enter-email' },
  { path: '/signin', redirect: '/enter-email' },
  { path: '/sign-in', redirect: '/enter-email' },
  { path: '/signup', redirect: '/enter-email' },
  { path: '/sign-up', redirect: '/enter-email' },
  { path: '/auth', redirect: '/enter-email' },
]
